import { html } from "lit";
import { ProductCategorizedOptionsTeasersTemplate } from "./ProductCategorizedOptionsTeasers.templates";

export const TabEquipment = () => html`
    <div id="tabEquipment">${ProductCategorizedOptionsTeasersTemplate()}</div>
`;
